/* Modulo: Card Spotlight — holographic 3D tilt + foil pointer tracking.
   Binds only on hover-capable, fine-pointer devices; touch & reduced-motion get the
   CSS idle shimmer instead. Vanilla IIFE; sections roll their own idempotent init +
   theme-editor lifecycle (no window.moduloLazyInit). */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var mm = window.matchMedia;
  var REDUCE = mm && mm('(prefers-reduced-motion: reduce)').matches;
  var HOVER = mm && mm('(hover: hover) and (pointer: fine)').matches;
  var ENABLED = HOVER && !REDUCE;
  var MAX_TILT = 16;

  function bindCard(card) {
    if (card.__csBound) return;
    card.__csBound = true;

    var raf = null, px = 0.5, py = 0.5;

    function paint() {
      raf = null;
      card.style.setProperty('--ry', ((px - 0.5) * 2 * MAX_TILT).toFixed(2) + 'deg');
      card.style.setProperty('--rx', ((0.5 - py) * 2 * MAX_TILT).toFixed(2) + 'deg');
      card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
    }
    function onMove(e) {
      var r = card.getBoundingClientRect();
      if (!r.width || !r.height) return;
      px = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      py = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
      if (!raf) raf = requestAnimationFrame(paint);
    }
    function enter() { card.classList.add('is-active'); card.style.setProperty('--pf', '1'); }
    function leave() {
      card.classList.remove('is-active');
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
      card.style.setProperty('--mx', '50%');
      card.style.setProperty('--my', '50%');
      card.style.setProperty('--pf', '0');
    }
    card.addEventListener('pointerenter', enter);
    card.addEventListener('pointermove', onMove);
    card.addEventListener('pointerleave', leave);
    card.__csUnbind = function () {
      card.removeEventListener('pointerenter', enter);
      card.removeEventListener('pointermove', onMove);
      card.removeEventListener('pointerleave', leave);
    };
  }

  function initSection(section) {
    if (!section || section.__csInit) return;
    section.__csInit = true;
    if (!ENABLED) return; // touch / reduced-motion → CSS idle shimmer only
    var cards = section.querySelectorAll('[data-modulo-cs-card]');
    for (var i = 0; i < cards.length; i++) bindCard(cards[i]);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('[data-modulo-cs]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* ─── Theme editor lifecycle ─── */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (!el) return;
    if (el.matches && el.matches('[data-modulo-cs]')) { el.__csInit = false; initSection(el); }
    else { initAll(el); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target;
    if (!el || !el.querySelectorAll) return;
    var cards = (el.matches && el.matches('[data-modulo-cs]'))
      ? el.querySelectorAll('[data-modulo-cs-card]')
      : el.querySelectorAll('[data-modulo-cs] [data-modulo-cs-card]');
    for (var i = 0; i < cards.length; i++) if (cards[i].__csUnbind) cards[i].__csUnbind();
  });
})();
